import  { useState } from "react";


const useLocalStorage = (key, defaultValue) => {
    const [storedValue, setstoredValue] = useState( () => 
    {
        try {
            const value = localStorage.getItem(key);

            if (value){
                return JSON.parse(value);
            }else{
                localStorage.setItem(key, JSON.stringify(defaultValue))
            }
        } catch(error){
            return defaultValue;
        }
    })



    const setValue = (newValue) => {
        try{
            localStorage.setItem(key, JSON.stringify(newValue));

        }catch(error){
            console.log(error);
        }
        setstoredValue(newValue)
    }

    return [storedValue, setValue]

    
}

export default useLocalStorage;

